const AUTH_CHANGE_PASSWORD_SCHEMA = schema
  .object({
    password: schema
      .string({
        required_error: localeValidation().required,
      })
      .min(8, {
        message: localeStringReplacement(localeValidation().lengthMin, {
          items: localeValidation().characters,
          length: "8",
        }),
      }),
    password_confirmed: schema
      .string({
        required_error: localeValidation().required,
      })
      .min(8, {
        message: localeStringReplacement(localeValidation().lengthMin, {
          items: localeValidation().characters,
          length: "8",
        }),
      }),
  })
  .superRefine(({ password, password_confirmed }, { addIssue }) => {
    if (password !== password_confirmed) {
      addIssue({
        code: "custom",
        message: localeStringReplacement(localeValidation().fieldsMatch, {
          fields: localeValidation().passwords,
        }),
        path: ["password_confirmed"],
      });
    }
  });

type AuthChangePasswordSchemaInfer = SchemaInfer<typeof AUTH_CHANGE_PASSWORD_SCHEMA>;

type AuthChangePasswordFields = FormFields<AuthChangePasswordSchemaInfer>;

type AuthChangePasswordForm = ChangePasswordPayload;

export { AUTH_CHANGE_PASSWORD_SCHEMA };
export type { AuthChangePasswordFields, AuthChangePasswordForm };
